export const environment ={
  production: true,
  hmr: false,
  host: '',
  client: 'diageo',
  orderWindowLabel: 'Order Window',
  onDemandLabel: 'Quick Buy',
}
